import { DEFAULT_LAYOUT_BOTTOM_PADDING_VALUE } from 'consts';
import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useState,
} from 'react';

type LayoutMainBottomPaddingSpacingContextType = number;

export const LayoutMainBottomPaddingSpacingContext = createContext<
  [
    LayoutMainBottomPaddingSpacingContextType,
    Dispatch<SetStateAction<LayoutMainBottomPaddingSpacingContextType>>,
  ]
>([DEFAULT_LAYOUT_BOTTOM_PADDING_VALUE, () => {}]);

type Props = {
  children: ReactNode;
};

export const LayoutMainBottomPaddingSpacingContextProvider = ({
  children,
}: Props) => {
  const layoutMainBottomPaddingSpacingState =
    useState<LayoutMainBottomPaddingSpacingContextType>(
      DEFAULT_LAYOUT_BOTTOM_PADDING_VALUE,
    );

  return (
    <LayoutMainBottomPaddingSpacingContext.Provider
      value={layoutMainBottomPaddingSpacingState}
    >
      {children}
    </LayoutMainBottomPaddingSpacingContext.Provider>
  );
};
